import React, { useState, useEffect, useRef } from 'react';
import {
  Map as CustomMap, Marker, Popup, FeatureGroup, Polygon, LayersControl,
} from 'react-leaflet';
import Control from 'react-leaflet-control';
import {
  ArrowLeftOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  PlusOutlined,
  WarningOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import {
  Modal, Button, Form, Input, Select, Tooltip, Card,
  Dropdown, Menu, notification, Row, Col, Typography,
  Spin, message,
} from 'antd';
import Undo from 'mdi-react/UndoIcon';
import Clear from 'mdi-react/ClearIcon';
import Eraser from 'mdi-react/EraserIcon';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { useNavigate } from 'react-router-dom';
import { EditControl } from 'react-leaflet-draw';
import { GoogleLayer } from 'react-leaflet-google-v2';
import polylabel from 'polylabel';
import AutocompleteGoogleMaps from '../../../sharedComponents/autocompleteGoogleMaps/AutocompleteGoogleMaps';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import './GeoMap.scss';
import mapcheckcustom from './mapcheckcustom.svg';

import {
  get, post, put, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../dataSource/requests';
import { SessionExpiredException } from '../../../../utils/errors';
import { brazilLocation, isLatitude, isLongitude } from '../../../../utils/LocationUtils';
import { calculatePolygonAreaInHectare } from '../../../../utils/GeometryUtils';
import { round } from '../../../../utils/MathUtils';
import AreaTalhao from '../../../sharedComponents/talhao/AreaTalhao';
import { MAP_API_KEY, MAP_CHANNEL_VERSION } from '../../../../utils/constants';

export const iconeSelecionado = new L.Icon({
  iconUrl: mapcheckcustom,
  iconAnchor: [13, 26],
  popupAnchor: [0, 0],
  iconSize: [26, 52],
});

const GeoMap = (props): JSX.Element => {
  const {
    params,
    previousPage,
    nextPage,
  } = props;

  const [formInstance] = Form.useForm();
  const navigate = useNavigate();
  const mapReference = useRef(undefined);
  const drawControlReference = useRef(undefined);
  const [modalTalhaoVisible, setModalTalhaoVisible] = useState<boolean>(false);
  const [shouldResetFields, setShouldResetFields] = useState<boolean>(false);
  const [talhaoPendenteRegistro, setTalhaoPendenteRegistro] = useState(null);
  const [drawEnabled, setDrawEnabled] = useState<boolean>(false);
  const [editInfoEnabled, setEditInfoEnabled] = useState<boolean>(false);
  const [editEnabled, setEditEnabled] = useState<boolean>(false);
  const [propriedades] = useState(params.selectedProperty.id);
  const [talhoes, setTalhoes] = useState([]);
  const [markersTalhoesSelecionados, setMarkersTalhoesSelecionados] = useState([]);
  const [talhoesSelecionados, setTalhoesSelecionados] = useState([]);
  const [talhaoEmDestaque, setTalhaoEmDestaque] = useState([]);
  const [talhaoPendenteRegistroLocal, setTalhaoPendenteRegistroLocal] = useState([]);
  const [talhoesComDetalhes, setTalhoesComDetalhes] = useState([]);
  const [cultures, setCultures] = useState([]);
  const [minimumValueHectar, setminimumValueHectar] = useState([]);
  const [salvarTalhaoLoading, setSalvarTalhaoLoading] = useState<boolean>(false);
  const [exibirDesenhoAnterior, setExibirDesenhoAnterior] = useState<boolean>(true);
  const [exibirCardsTalhaoInfo, setExibirCardsTalhaoInfo] = useState<boolean>(true);
  const [lastLayerAddedID, setLastLayerAddedID] = useState(undefined);

  const [
    talhaoPendenteConfirmacaoEdicao,
    setTalhaoPendenteConfirmacaoEdicao,
  ] = useState(null);

  const [
    talhaoPendenteConfirmacaoEdicaoLocal,
    setTalhaoPendenteConfirmacaoEdicaoLocal,
  ] = useState(null);

  const [shouldAskGeoPermission] = useState<boolean>(true);
  const [enableGeoSearch, setEnableGeoSearch] = useState<boolean>(false);
  const [currentPosition, setCurrentPosition] = useState<Array<number>>(brazilLocation);
  const [defaultPosition] = useState(brazilLocation);
  const [novoDesenhoFinalizado, setNovoDesenhoFinalizado] = useState<boolean>(false);
  const [loading, setLoading] = useState({
    active: false,
    text: '',
  });

  const onShapeCreatedEdit = (eventt: any): void => {
    const latLonArray = {
      coordinates: [],
      area: null,
    };

    const latLonArrayLocal = {
      coordinates: [],
      area: null,
    };

    if (eventt.layer.intersects()) {
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        .removeLayer(eventt.layer);

      notification.error({
        message: 'Erro',
        description: `Para desenhar o talhão, inclua os pontos 
        que o contornam, de forma sequencial, sem cruzar as linhas traçadas.`,
      });

      return;
    }

    setLastLayerAddedID(eventt.layer._leaflet_id);

    eventt.layer.toGeoJSON().geometry.coordinates[0].forEach((latlng, index) => {
      latLonArray.coordinates[index] = {
        lat: latlng[1],
        lon: latlng[0],
      };

      latLonArrayLocal.coordinates[index] = [latlng[1], latlng[0]];
    });

    const areaHec = calculatePolygonAreaInHectare(latLonArray.coordinates);

    if (areaHec) {
      latLonArray.area = areaHec;
    }

    setTalhaoPendenteConfirmacaoEdicao(latLonArray);
    setTalhaoPendenteConfirmacaoEdicaoLocal(latLonArrayLocal);
    setExibirCardsTalhaoInfo(false);
    setNovoDesenhoFinalizado(true);
  };

  const handleLoading = (active, text): void => {
    setLoading({ active, text });
  };

  const disableDraw = (): void => {
    drawControlReference
      .current
      .leafletElement
      ._toolbars
      .draw
      ._modes
      .polygon
      .handler
      .disable();

    setDrawEnabled(false);
    setExibirCardsTalhaoInfo(true);
  };

  const onShapeCreatedDraw = (eventt: any): void => {
    if (eventt.layer.intersects()) {
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        .removeLayer(eventt.layer);
      disableDraw();

      notification.error({
        message: 'Erro',
        description: `Para desenhar o talhão, inclua os pontos 
        que o contornam, de forma sequencial, sem cruzar as linhas traçadas.`,
      });

      return;
    }

    setLastLayerAddedID(eventt.layer._leaflet_id);

    const latLonArray = {
      area: null,
      coordinates: [],
    };

    const latLonArrayLocal = {
      area: null,
      coordinates: [],
    };

    eventt.layer.toGeoJSON().geometry.coordinates[0].forEach((latlng, index) => {
      latLonArray.coordinates[index] = {
        lat: latlng[1],
        lon: latlng[0],
      };

      latLonArrayLocal.coordinates[index] = [latlng[1], latlng[0]];
    });

    const areaHec = calculatePolygonAreaInHectare(latLonArray.coordinates);

    if (areaHec) {
      latLonArray.area = areaHec;
    }

    setTalhaoPendenteRegistro(latLonArray);
    setTalhaoPendenteRegistroLocal(latLonArrayLocal);
  };

  const toggleDesenhoAnterior = (exibirDesenhoAnteriorP): void => {
    setExibirDesenhoAnterior(exibirDesenhoAnteriorP);
  };

  const toggleSelection = (eventt): void => {
    const centroVerdadeiro = polylabel(eventt.target.toGeoJSON().geometry.coordinates, 1.0);
    let clicked;
    const talhoesSelecionadosCopia = Array.from(talhoesSelecionados);
    const talhoesSelecionadosChave = [];
    const markersTalhoesSelecionadosCopia = Array.from(markersTalhoesSelecionados);
    let newTalhaoEmDestaque = [];
    const encontrados = [];

    talhoes.forEach((elemento, talhaoAtual) => {
      if (elemento.key === eventt.target.options._leaflet_id) {
        clicked = talhaoAtual;
      }
    });

    if (clicked == null) {
      notification.error({
        message: 'Erro',
        description: `Houve um problema com a sua solicitação. 
        Tente novamente por favor`,
      });
      return;
    }

    talhoesSelecionadosCopia.forEach((talhao) => {
      talhoesSelecionadosChave.push(talhao.id);
    });

    if (talhoesSelecionadosChave.includes(talhoes[clicked].key)) {
      talhoesSelecionadosCopia.forEach((talhao, index) => {
        if (talhao.id === talhoes[clicked].key) {
          talhoesSelecionadosCopia.splice(index, 1);
          talhoesSelecionadosChave.splice(index, 1);
        }
      });

      newTalhaoEmDestaque = talhoesComDetalhes.find(
        (elemento) => elemento.id === talhoesSelecionadosChave[talhoesSelecionadosCopia.length - 1],
      );
    } else {
      talhoesSelecionadosCopia.push(talhoesComDetalhes[clicked]);
      talhoesSelecionadosChave.push(talhoesComDetalhes[clicked].id);
      newTalhaoEmDestaque = talhoesComDetalhes[clicked];
    }

    if (markersTalhoesSelecionadosCopia.length) {
      markersTalhoesSelecionadosCopia.forEach((marker, markerIndex) => {
        if (marker[0] === centroVerdadeiro[1] && marker[1] === centroVerdadeiro[0]) {
          encontrados.push(markerIndex);
        }
      });

      if (encontrados.length) {
        encontrados.forEach((value) => markersTalhoesSelecionadosCopia.splice(value, 1));
      } else {
        markersTalhoesSelecionadosCopia.push([centroVerdadeiro[1], centroVerdadeiro[0]]);
      }
    } else {
      markersTalhoesSelecionadosCopia.push([centroVerdadeiro[1], centroVerdadeiro[0]]);
    }

    if (talhoesSelecionadosCopia.length === 0) {
      newTalhaoEmDestaque = [];
    } else if (talhoesSelecionadosCopia.length === 1) {
      [newTalhaoEmDestaque] = talhoesSelecionadosCopia;
    }

    setMarkersTalhoesSelecionados(markersTalhoesSelecionadosCopia);
    setTalhoesSelecionados(talhoesSelecionadosCopia);
    setTalhaoEmDestaque(newTalhaoEmDestaque);
  };

  const desenhoTalhoes = (): JSX.Element[] => {
    let borderColor;
    let borderOpacity;
    let polygonColor;
    let polygonOpacity;

    return talhoes.map((value) => {
      switch (true) {
        case (Number.parseInt(value.key, 10) === talhaoEmDestaque.id)
          && editEnabled
          && exibirDesenhoAnterior:
          borderColor = '#9E9E9E';
          borderOpacity = '0.0';
          polygonColor = '#9E9E9E';
          polygonOpacity = '0.77';
          break;

        case (Number.parseInt(value.key, 10) === talhaoEmDestaque.id)
          && editEnabled
          && !exibirDesenhoAnterior:
          borderColor = 'rgba(0, 0, 0, 0.45)';
          borderOpacity = '0';
          polygonColor = 'rgba(0, 0, 0, 0.45)';
          polygonOpacity = '0';
          break;

        case (!editEnabled && !drawEnabled)
          && Number.parseInt(value.key, 10) === talhaoEmDestaque.id:
          borderColor = '#fabe46';
          borderOpacity = '1.0';
          polygonColor = 'rgba(36, 101, 74, 0.6)';
          polygonOpacity = '1.0';
          break;

        default:
          borderColor = '#fabe46';
          borderOpacity = '1.0';
          polygonColor = 'rgba(216, 216, 216, 0.6)';
          polygonOpacity = '1.0';
          break;
      }

      return (
        <Polygon
          onClick={!editEnabled ? (eventt): void => toggleSelection(eventt) : (): void => { }}
          key={`talhao-${value.key}`}
          _leaflet_id={value.key}
          positions={value.pontos}
          color={borderColor}
          opacity={borderOpacity}
          fillColor={polygonColor}
          fillOpacity={polygonOpacity}
        />
      );
    });
  };

  const deletarTalhaoDestacado = (): void => {
    let talhaoID;
    let coordinatesTalhao;
    let centroVerdadeiro;
    const talhaoDados = talhaoEmDestaque;
    const talhoesCopia = Array.from(talhoes);
    const talhoesComDetalhesCopia = Array.from(talhoesComDetalhes);
    let talhaoEmDestaqueCopia = talhaoEmDestaque;
    const markersTalhoesSelecionadosCopia = Array.from(markersTalhoesSelecionados);
    const talhoesSelecionadosCopia = Array.from(talhoesSelecionados);

    Modal.confirm({
      title: 'Atenção',
      content: 'Deseja excluir o talhão informado?',
      okText: 'Sim, excluir',
      cancelText: 'Não, cancelar',
      icon: (<WarningOutlined />),

      onOk: async () => {
        let response: ResponseWrapper | undefined;
        let responseError: ResponseWrapper | undefined;
        let genericError: Error | undefined;

        if (!talhaoEmDestaque || !talhaoEmDestaque.id) {
          notification.error({
            message: 'Erro',
            description: 'Desculpe, não foi possivel excluir o talhão. Por favor, tente novamente.',
          });
        }

        talhaoID = talhaoDados.id;

        try {
          const deleteFieldReqRef: RequestWrapper = put({
            url: `/land/deleteField?id=${talhaoID}`,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          response = await deleteFieldReqRef;
        } catch (error) {
          if (!(error instanceof SessionExpiredException)) {
            const ex = JSON.parse(error.message);

            if (ex.description === 'Land field can not be excluded') {
              notification.warning({
                message: 'Aviso',
                description: 'Este talhão não pode ser removido porque possui resultados associados.',
              });
            } else {
              notification.error({
                message: 'Erro',
                description: 'Desculpe, houve um erro ao excluir o talhao. Por favor, tente novamente.',
              });
            }
          }

          return;
        }

        if (!response?.body.error) {
          talhoesCopia.forEach((elemento, elementoIndice) => {
            if (elemento.key === talhaoID) {
              talhoesCopia.splice(elementoIndice, 1);
            }
          });

          talhoesSelecionadosCopia.forEach((elemento, elementoIndice) => {
            if (elemento.id === talhaoID) {
              talhoesSelecionadosCopia.splice(elementoIndice, 1);
            }
          });

          talhoesComDetalhesCopia.forEach((elemento, elementoIndice) => {
            if (elemento.id === talhaoID) {
              talhoesComDetalhesCopia.splice(elementoIndice, 1);
            }
          });

          talhaoEmDestaqueCopia = talhoesSelecionados.length > 1
            ? talhoesComDetalhesCopia
              .find(
                (elemento) => elemento.id === talhoesSelecionadosCopia[
                  talhoesSelecionadosCopia.length - 1
                ].id,
              )
            : [];

          coordinatesTalhao = [talhaoDados.polygon.map((ponto) => [ponto.lon, ponto.lat])];
          centroVerdadeiro = polylabel(coordinatesTalhao, 1.0);

          markersTalhoesSelecionadosCopia.forEach((marker, indiceMarker) => {
            if (marker[0] === centroVerdadeiro[1] && marker[1] === centroVerdadeiro[0]) {
              markersTalhoesSelecionadosCopia.splice(indiceMarker, 1);
            }
          });

          setTalhoes(talhoesCopia);
          setTalhoesComDetalhes(talhoesComDetalhesCopia);
          setTalhaoEmDestaque(talhaoEmDestaqueCopia);
          setMarkersTalhoesSelecionados(markersTalhoesSelecionadosCopia);
          setTalhoesSelecionados(talhoesSelecionadosCopia);

          notification.success({
            message: 'Sucesso',
            description: 'Talhão excluir com sucesso.',
          });
        } else {
          notification.error({
            message: 'Erro',
            description: 'Desculpe, houve um erro ao excluir o talhao. Por favor, tente novamente.',
          });
        }
      },

      onCancel() { },
    });
  };

  const buscarBasicParameters = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const { params: { selectedService } } = props;

    try {
      const getServiceBasicParametersReqRef: RequestWrapper = get({
        url: `/system/getServiceBasicParameters/${selectedService.id}`,

        params: {
          id: selectedService.id,
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await getServiceBasicParametersReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 8004):
        // "Services parameters got successfully", 8004
        setminimumValueHectar(
          response?.body.getServicesParametersOutput
            .serviceParameters.minimumAmountOfHectares,
        );
        break;

      case (responseError?.body?.code === -8000):
        // "Service not found", -8000
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Houve um erro ao executar sua solicitação.',
        });
        break;
    }
  };

  const buscarCulturas = async (): Promise<void> => {
    const land = params.selectedProperty;
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const retrieveCulturesByLandReqRef: RequestWrapper = get({
        url: `/land/retrieveCulturesByLand?landId=${land.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await retrieveCulturesByLandReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 6003): {
        // "Cultures retrieved by land successfully", 6003
        const newCultures = [];
        response?.body.cultures.forEach((culture) => newCultures.push(culture));
        setCultures(newCultures);
      } break;

      case (responseError?.body?.code === -6002):
        // "Land not found", -6002
        notification.error({
          message: 'Erro',
          description: 'Propriedade não encontrada.',
        });
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao buscar as culturas da propriedade.',
        });
        break;
    }
  };

  const definePosition = ({ talh }): void => {
    let newEnableGeoSearch = enableGeoSearch;

    let finalPosition;

    switch (true) {
      case (
        params.selectedProperty.location.lat != null
        && params.selectedProperty.location.lat != ''
        && isLatitude(params.selectedProperty.location.lat)
        && params.selectedProperty.location.lon != null
        && params.selectedProperty.location.lon != ''
        && isLongitude(params.selectedProperty.location.lon)
      ):
        finalPosition = [
          params.selectedProperty.location.lat,
          params.selectedProperty.location.lon,
        ];

        newEnableGeoSearch = false;
        break;

      case (talh != null && talh.length > 0):
        finalPosition = talh[0].pontos[0];

        newEnableGeoSearch = false;
        break;

      case (shouldAskGeoPermission):
        newEnableGeoSearch = true;

        window
          .navigator
          .geolocation
          .getCurrentPosition((position) => {
            finalPosition = [
              position.coords.latitude,
              position.coords.longitude,
            ];

            setCurrentPosition(finalPosition);
          }, () => {
            setCurrentPosition(defaultPosition);
          });

        break;

      default:
        finalPosition = defaultPosition;
        newEnableGeoSearch = true;
        break;
    }

    setCurrentPosition(finalPosition);
    setEnableGeoSearch(newEnableGeoSearch);
  };

  const buscarTalhoes = async (): Promise<void> => {
    const land = params.selectedProperty;

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const retrieveLandFieldsByLandAndCultureReqRef: RequestWrapper = get({
        url: `/land/retrieveLandFieldsByLandAndCulture?landId=${land.id}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await retrieveLandFieldsByLandAndCultureReqRef;
    } catch (error) {
      console.log(error);

      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 6001): {
        // "Land fields retrieved by land successfully", 6001
        const landFields = [];

        if (response?.body.landFields.length > 0) {
          response?.body.landFields.forEach((landField) => {
            const pontos = [];

            landField.polygon.forEach((landFieldEach) => {
              pontos.push([landFieldEach.lat, landFieldEach.lon]);
            });

            pontos.pop();
            landFields.push({ key: landField.id, pontos });
          });

          setTalhoes(landFields);
          setTalhoesComDetalhes(
            response?.body.landFields.map((landDetailEach) => {
              if ('area' in landDetailEach && landDetailEach.area != null) {
                return (landDetailEach);
              }

              return ({
                ...landDetailEach,

                area: calculatePolygonAreaInHectare(landDetailEach.polygon),
              });
            }),
          );
        } else {
          Modal.confirm({
            title: 'Atenção',
            content: 'Nenhum talhão cadastrado nessa propriedade',
            okText: 'ok',
            autoFocusButton: 'ok',
            okCancel: false,
            icon: (<WarningOutlined />),
            onOk: () => { },
          });
        }

        definePosition({ talh: landFields });
      } break;

      case (responseError?.body?.code === -6002):
        // "Land not found", -6002
        notification.error({
          message: 'Erro',
          description: 'Propriedade não encontrada.',
        });
        definePosition();
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        definePosition();
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao buscar os talhoes.',
        });
        definePosition();
        break;
    }
  };

  const cancelarNovoTalhao = (): void => {
    drawControlReference
      .current
      .leafletElement
      .options
      .edit
      .featureGroup
      .removeLayer(
        lastLayerAddedID,
      );

    setModalTalhaoVisible(false);
    setTalhaoPendenteRegistro(undefined);
    setTalhaoPendenteRegistroLocal(undefined);
    disableDraw();
    setLastLayerAddedID(undefined);
  };

  const enableDraw = (): void => {
    if (talhaoPendenteRegistro) {
      cancelarNovoTalhao();
    }

    drawControlReference
      .current
      .leafletElement
      ._toolbars
      .draw
      ._modes
      .polygon
      .handler
      .enable();

    setDrawEnabled(true);
    setExibirCardsTalhaoInfo(false);
  };

  const handleCancelButton = (): void => {
    if (drawEnabled) {
      disableDraw();
      enableDraw();
    }

    if (editEnabled) {
      drawControlReference
        .current
        .leafletElement
        ._toolbars
        .draw
        ._modes
        .polygon
        .handler
        .disable();

      drawControlReference
        .current
        .leafletElement
        ._toolbars
        .draw
        ._modes
        .polygon
        .handler
        .enable();
    }

    if (talhaoPendenteConfirmacaoEdicao) {
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        .removeLayer(
          lastLayerAddedID,
        );

      setTalhaoPendenteConfirmacaoEdicao(undefined);
      setTalhaoPendenteConfirmacaoEdicaoLocal(undefined);
      setNovoDesenhoFinalizado(false);
      setLastLayerAddedID(undefined);
    }

    if (talhaoPendenteRegistro) {
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        .removeLayer(
          lastLayerAddedID,
        );

      setTalhaoPendenteRegistro(undefined);
      setTalhaoPendenteRegistroLocal(undefined);
      setLastLayerAddedID(undefined);
    }
  };

  const cancelarEdicaoDesenhoTalhao = (): void => {
    setEditEnabled(false);
    setExibirCardsTalhaoInfo(true);
  };

  const handleTalhaoButton = (): void => {
    if (!drawEnabled && !talhaoPendenteRegistro && !editEnabled) {
      enableDraw();
    } else if (talhaoPendenteRegistro) {
      handleCancelButton();
      disableDraw();
    } else if (drawEnabled) {
      disableDraw();
    } else if (editEnabled) {
      handleCancelButton();

      drawControlReference
        .current
        .leafletElement
        ._toolbars
        .draw
        ._modes
        .polygon
        .handler
        .disable();

      cancelarEdicaoDesenhoTalhao();
    }
  };

  const desfazer = (): void => {
    drawControlReference
      .current
      .leafletElement
      ._toolbars
      .draw
      ._modes
      .polygon
      .handler
      .deleteLastVertex();
  };

  const abrirModalTalhao = (): void => {
    setModalTalhaoVisible(true);
    setShouldResetFields(true);
  };

  const habilitarEdicaoInfoTalhao = (): void => {
    setModalTalhaoVisible(true);
    setEditInfoEnabled(true);
    setShouldResetFields(true);
  };

  const validarTalhoes = (): boolean => {
    let erro = 0;
    let qtd = 0;

    const { params: { selectedService, selectedType, selectedSubType } } = props;
    // geofert zona de manejo ou satélite, validação hardcode temporaria
    // pegar areaMinima
    let talhaoArea = 0.0;
    if (selectedSubType != undefined) {
      let talhaoDif = false;
      if (
        selectedSubType.name == 'Vant'
        || (
          selectedService.name === 'Geofert'
          && selectedType.name === 'Zona de manejo'
          && selectedSubType.name === 'Satélite'
        )
      ) {
        let proxCult;
        for (const talhao in talhoesSelecionados) {
          proxCult = talhoesSelecionados[talhao].culture;
          if (talhao < talhoesSelecionados.length - 1) {
            proxCult = talhoesSelecionados[Number.parseInt(talhao, 10) + 1].culture;
          }
          if (talhoesSelecionados[talhao].culture != proxCult) {
            talhaoDif = true;
          }
        }
      }
      if (talhaoDif) {
        notification.error({
          message: 'Erro',
          description: `Para a solicitação de ${selectedService.name} do tipo ${selectedSubType.name} todos os talhões devem ter o mesmo tipo de cultura`,
        });
        erro += 1;
      }
    }

    for (const talhao in talhoesSelecionados) {
      if (talhoesSelecionados[talhao].area != null) {
        talhaoArea += talhoesSelecionados[talhao].area;
      }
    }

    talhaoArea = talhaoArea.toFixed(2);

    if (talhaoArea < minimumValueHectar) {
      notification.warning({
        message: 'Atenção',
        description: `A quantidade mínima permitida para a solicitação de ${selectedService.name} é de ${minimumValueHectar} hectares`,
      });
      erro += 1;
    }

    if (
      selectedService.name === 'Satélite'
    ) {
      qtd = talhoesSelecionados
        .filter((selecionado) => selecionado.culture !== '051').length;

      if (qtd > 0) {
        erro += 1;

        notification.error({
          message: 'Erro',
          description: 'Cultura do(s) talhão(ões) deve ser cana de açúcar para esse tipo de serviço',
        });
      }
    }

    return erro === 0;
  };

  const habilitarEdicaoDesenhoTalhao = (): void => {
    setEditEnabled(true);
    setExibirCardsTalhaoInfo(false);
    setNovoDesenhoFinalizado(false);

    drawControlReference
      .current
      .leafletElement
      ._toolbars
      .draw
      ._modes
      .polygon
      .handler
      .enable();
  };

  const salvarEdicaoDesenhoTalhao = async (): Promise<void> => {
    const talhoesComDetalhesCopia = Array.from(talhoesComDetalhes);
    const talhoesSelecionadosCopia = Array.from(talhoesSelecionados);
    let talhaoEmDestaqueCopia = talhaoEmDestaque;
    const talhaoDados = talhaoEmDestaque;
    const talhoesCopia = Array.from(talhoes);
    let shouldDelete = false;
    const novosPontos = Array.from(talhaoPendenteConfirmacaoEdicaoLocal.coordinates);
    const markersTalhoesSelecionadosCopia = Array.from(markersTalhoesSelecionados);
    let coordinatesTalhao;
    let coordinatesTalhaoNovo;
    let centroVerdadeiro;
    let centroVerdadeiroNovo;
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;
    novosPontos.pop();

    const payload = {
      ...talhaoEmDestaqueCopia,
      landId: propriedades,
      coordinates: talhaoPendenteConfirmacaoEdicao.coordinates,
      area: talhaoPendenteConfirmacaoEdicao.area,
      landFieldId: talhaoEmDestaqueCopia.id,
    };

    const keys = Object.keys(
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        ._layers,
    );

    if (keys.length > talhoes.length) {
      shouldDelete = true;
    }

    try {
      const landEditField: RequestWrapper = put({
        url: '/land/editField',
        params: payload,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await landEditField;
    } catch (newError) {
      if (shouldDelete) {
        drawControlReference
          .current
          .leafletElement
          .options
          .edit
          .featureGroup
          .removeLayer(
            lastLayerAddedID,
          );

        setLastLayerAddedID(undefined);
      }

      setTalhaoPendenteConfirmacaoEdicao(undefined);
      setTalhaoPendenteConfirmacaoEdicaoLocal(undefined);
      setEditEnabled(false);
      setExibirCardsTalhaoInfo(true);
      setNovoDesenhoFinalizado(false);

      if (!(newError instanceof SessionExpiredException)) {
        notification.error({
          message: 'Erro',
          description: `Desculpe, houve um problema com a sua solicitação. 
                Tente novamente por favor`,
        });
      }

      drawControlReference
        .current
        .leafletElement
        ._toolbars
        .draw
        ._modes
        .polygon
        .handler
        .disable();

      return;
    }

    if (!response?.body.error) {
      talhaoEmDestaqueCopia = {
        ...talhaoEmDestaqueCopia,
        id: response?.body.entityId,
        polygon: talhaoPendenteConfirmacaoEdicao.coordinates,
        area: talhaoPendenteConfirmacaoEdicao.area,
      };

      talhoesComDetalhesCopia.forEach((elemento, indice) => {
        if (elemento.id === talhaoEmDestaque.id) {
          talhoesComDetalhesCopia.splice(indice, 1, talhaoEmDestaqueCopia);
        }
      });

      talhoesSelecionadosCopia.forEach((elemento, indice) => {
        if (elemento.id === talhaoEmDestaque.id) {
          talhoesSelecionadosCopia.splice(indice, 1, talhaoEmDestaqueCopia);
        }
      });

      talhoesCopia.forEach((elemento, indice) => {
        if (elemento.key === talhaoEmDestaque.id) {
          talhoesCopia.splice(indice, 1, {
            key: talhaoEmDestaqueCopia.id,
            pontos: novosPontos,
          });
        }
      });

      coordinatesTalhao = [talhaoDados.polygon.map((ponto) => [ponto.lon, ponto.lat])];
      centroVerdadeiro = polylabel(coordinatesTalhao, 1.0);

      coordinatesTalhaoNovo = [
        talhaoEmDestaqueCopia.polygon.map(
          (ponto) => [ponto.lon, ponto.lat],
        ),
      ];

      centroVerdadeiroNovo = polylabel(coordinatesTalhaoNovo, 1.0);

      markersTalhoesSelecionadosCopia.forEach((marker, indiceMarker) => {
        if (marker[0] === centroVerdadeiro[1] && marker[1] === centroVerdadeiro[0]) {
          markersTalhoesSelecionadosCopia
            .splice(indiceMarker, 1, [centroVerdadeiroNovo[1], centroVerdadeiroNovo[0]]);
        }
      });

      if (shouldDelete) {
        drawControlReference
          .current
          .leafletElement
          .options
          .edit
          .featureGroup
          .removeLayer(
            lastLayerAddedID,
          );

        setLastLayerAddedID(undefined);
      }

      setTalhoes(talhoesCopia);
      setTalhoesComDetalhes(talhoesComDetalhesCopia);
      setTalhoesSelecionados(talhoesSelecionadosCopia);
      setTalhaoEmDestaque(talhaoEmDestaqueCopia);
      setEditEnabled(false);
      setExibirCardsTalhaoInfo(true);
      setTalhaoPendenteConfirmacaoEdicao(undefined);
      setTalhaoPendenteConfirmacaoEdicaoLocal(undefined);
      setMarkersTalhoesSelecionados(markersTalhoesSelecionadosCopia);
      setNovoDesenhoFinalizado(false);

      notification.success({
        message: 'Sucesso',
        description: 'Desenho do talhão editado com sucesso.',
      });
    } else {
      if (shouldDelete) {
        drawControlReference
          .current
          .leafletElement
          .options
          .edit
          .featureGroup
          .removeLayer(
            lastLayerAddedID,
          );

        setLastLayerAddedID(undefined);
      }

      setTalhaoPendenteConfirmacaoEdicao(undefined);
      setTalhaoPendenteConfirmacaoEdicaoLocal(undefined);
      setEditEnabled(false);
      setExibirCardsTalhaoInfo(true);
      setNovoDesenhoFinalizado(false);

      notification.error({
        message: 'Erro',
        description: `Desculpe, houve um problema com a sua solicitação. 
              Tente novamente por favor`,
      });
    }

    drawControlReference
      .current
      .leafletElement
      ._toolbars
      .draw
      ._modes
      .polygon
      .handler
      .disable();
  };

  const salvarEdicaoInfoTalhao = async (): Promise<void> => {
    const talhoesComDetalhesCopia = Array.from(talhoesComDetalhes);
    const talhoesSelecionadosCopia = Array.from(talhoesSelecionados);
    const talhoesCopia = Array.from(talhoes);

    let talhaoEmDestaqueCopia;

    setSalvarTalhaoLoading(true);

    let values;
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      values = await formInstance.validateFields();
    } catch (error) {
      console.log(error);
      setSalvarTalhaoLoading(false);
      return;
    }

    if (values.details === null || !values.details) {
      values.details = '';
    }

    const payload = {
      ...values,
      landId: propriedades,
      coordinates: talhaoEmDestaque.polygon,
      landFieldId: talhaoEmDestaque.id,
      area: talhaoEmDestaque.area,
    };

    try {
      const landEditField: RequestWrapper = put({
        url: '/land/editField',
        params: payload,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await landEditField;
    } catch (newError) {
      if (!(newError instanceof SessionExpiredException)) {
        notification.error({
          message: 'Erro',
          description: `Desculpe, houve um problema com a sua solicitação. 
                Tente novamente por favor`,
        });
      }

      setSalvarTalhaoLoading(false);
      return;
    }

    if (!response?.body.error) {
      talhaoEmDestaqueCopia = {
        ...talhaoEmDestaque,
        ...values,
        id: response?.body.entityId,
      };

      talhoesComDetalhesCopia.forEach((elemento, indice) => {
        if (elemento.id === talhaoEmDestaque.id) {
          talhoesComDetalhesCopia.splice(indice, 1, talhaoEmDestaqueCopia);
        }
      });

      talhoesSelecionadosCopia.forEach((elemento, indice) => {
        if (elemento.id === talhaoEmDestaque.id) {
          talhoesSelecionadosCopia.splice(indice, 1, talhaoEmDestaqueCopia);
        }
      });

      talhoesCopia.forEach((elemento, indice) => {
        if (elemento.key === talhaoEmDestaque.id) {
          talhoesCopia[indice].key = response?.body.entityId;
        }
      });

      setTalhoes(talhoesCopia);
      setTalhoesComDetalhes(talhoesComDetalhesCopia);
      setTalhoesSelecionados(talhoesSelecionadosCopia);
      setTalhaoEmDestaque(talhaoEmDestaqueCopia);
      setModalTalhaoVisible(false);
      setEditInfoEnabled(false);
      setSalvarTalhaoLoading(false);

      notification.success({
        message: 'Sucesso',
        description: 'Talhão editado com sucesso.',
      });
    } else {
      notification.error({
        message: 'Erro',
        description: `Desculpe, houve um problema com a sua solicitação. 
              Tente novamente por favor`,
      });
    }

    setSalvarTalhaoLoading(false);
  };

  const limparFormTalhao = (): void => {
    formInstance.resetFields();
  };

  const cancelarEdicaoInfoTalhao = (): void => {
    limparFormTalhao();

    setModalTalhaoVisible(false);
    setEditInfoEnabled(false);
  };

  const salvarNovoTalhao = async (): Promise<void> => {
    setSalvarTalhaoLoading(true);

    let values;
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      values = await formInstance.validateFields();
    } catch (error) {
      console.log(error);

      setSalvarTalhaoLoading(false);

      return;
    }

    if (values.details === null || !values.details) {
      values.details = '';
    }

    const payload = {
      ...values,
      landId: propriedades,
      coordinates: talhaoPendenteRegistro.coordinates,
      area: talhaoPendenteRegistro.area,
    };

    const keys = Object.keys(
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        ._layers,
    );

    let shouldDelete = false;

    if (keys.length > talhoes.length) {
      shouldDelete = true;
    }

    try {
      const landFieldReqRef: RequestWrapper = post({
        url: '/land/field',
        params: payload,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await landFieldReqRef;
    } catch (newError) {
      if (!(newError instanceof SessionExpiredException)) {
        notification.error({
          message: 'Erro',
          description: `Desculpe, houve um problema com a sua solicitação. 
          Tente novamente por favor`,
        });
      }

      if (shouldDelete) {
        drawControlReference
          .current
          .leafletElement
          .options
          .edit
          .featureGroup
          .removeLayer(
            lastLayerAddedID,
          );

        setLastLayerAddedID(undefined);
      }

      setSalvarTalhaoLoading(false);
      setModalTalhaoVisible(false);
      setTalhaoPendenteRegistro(undefined);
      setTalhaoPendenteRegistroLocal(undefined);
      return;
    }

    if (!response?.body.error) {
      const talhoesCopia = talhoes;
      const talhoesComDetalhesCopia = talhoesComDetalhes;

      talhoesCopia.push({
        key: response?.body.entityId ? Number.parseInt(response?.body.entityId, 10) : 0,
        pontos: talhaoPendenteRegistroLocal.coordinates,
      });

      talhoesComDetalhesCopia.push({
        id: Number.parseInt(response?.body.entityId, 10),
        name: values.name,
        culture: cultures.find((culture) => culture.id === values.culture).id,
        details: values.details,
        landId: propriedades,
        polygon: talhaoPendenteRegistro.coordinates,
        area: talhaoPendenteRegistro.area,
      });

      notification.success({
        message: 'Sucesso',
        description: 'Talhão criado com sucesso.',
      });

      setTalhoes(talhoesCopia);
      setTalhoesComDetalhes(talhoesComDetalhesCopia);
      setSalvarTalhaoLoading(false);
    } else {
      setSalvarTalhaoLoading(false);

      notification.error({
        message: 'Erro',
        description: `Desculpe, houve um problema com a sua solicitação. 
            Tente novamente por favor`,
      });
    }

    if (shouldDelete) {
      drawControlReference
        .current
        .leafletElement
        .options
        .edit
        .featureGroup
        .removeLayer(
          lastLayerAddedID,
        );

      setLastLayerAddedID(undefined);
    }

    setModalTalhaoVisible(false);
    setTalhaoPendenteRegistro(undefined);
    setTalhaoPendenteRegistroLocal(undefined);
    disableDraw();
    setDrawEnabled(false);
  };

  const mensagemTalhao = (): string => {
    switch (true) {
      case drawEnabled:
        return 'Adicionar talhão';

      case editEnabled:
        return 'Editar talhão';

      default:
        return 'Selecione o talhão';
    }
  };

  const selecionarTalhoes = (): void => {
    const newTalhoesSelecionados = [];
    const newMarkersTalhoesSelecionados = [];

    let coordinatesTalhao;
    let centroVerdadeiro;
    let newtalhaoEmDestaque = [];

    const talhoesValues = Object.values(props.params.talhoesSelecionados);

    for (const talhao of talhoesValues) {
      if (talhao.landId !== propriedades) {
        continue;
      }

      newTalhoesSelecionados.push({
        ...talhao,
        culture: talhao.culture.id,
      });

      coordinatesTalhao = [talhao.polygon.map((ponto) => [ponto.lon, ponto.lat])];
      centroVerdadeiro = polylabel(coordinatesTalhao, 1.0);

      newMarkersTalhoesSelecionados.push([centroVerdadeiro[1], centroVerdadeiro[0]]);
      newtalhaoEmDestaque = {
        ...talhao,
        culture: talhao.culture.id,
      };
    }

    if (newTalhoesSelecionados.length === 0) {
      newtalhaoEmDestaque = [];
    } else if (newTalhoesSelecionados.length === 1) {
      [newtalhaoEmDestaque] = newTalhoesSelecionados;
    }

    setTalhoesSelecionados(newTalhoesSelecionados);
    setMarkersTalhoesSelecionados(newMarkersTalhoesSelecionados);
    setTalhaoEmDestaque(newtalhaoEmDestaque);
  };

  const handleSelectedLocation = (lat: number, lng:number): void => {
    setCurrentPosition([lat, lng]);
  };

  const handleMarkerPosition = (): void => { };

  const showAreaTalhao = (): number | null => {
    switch (true) {
      case (editInfoEnabled):
        return round(talhaoEmDestaque.area, 2);

      case (talhaoPendenteRegistro != null):
        return round(talhaoPendenteRegistro.area, 2);

      case (talhaoPendenteConfirmacaoEdicao != null):
        return round(talhaoPendenteConfirmacaoEdicao.area, 2);

      default:
        return null;
    }
  };

  const initialCalls = async (): Promise<void> => {
    handleLoading(true, 'Buscando dados...');
    await buscarTalhoes();
    await buscarCulturas();
    await buscarBasicParameters();
    selecionarTalhoes();
    handleLoading(false, '');
  };

  useEffect(() => {
    initialCalls();

    return () => {
      setSalvarTalhaoLoading(false);
    };
  }, []);

  useEffect(() => {
    if (shouldResetFields) {
      formInstance.resetFields();
      setShouldResetFields(false);
    }
  }, [shouldResetFields]);

  L.drawLocal.draw.handlers.polygon.tooltip.start = 'Clique para começar a desenhar o talhão.';
  L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Clique para continuar desenhando o talhão.';
  L.drawLocal.draw.handlers.polygon.tooltip.end = 'Clique no primeiro ponto para finalizar o desenho do talhão.';

  return (
    <Spin tip={loading.text} spinning={loading.active}>
      <div id="mapa-add-talhao" className={talhoesSelecionados.length === 0 ? 'GeoMap' : 'GeoMapConditional'}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '100%', textAlign: 'left', marginBottom: '8px' }}>
            <span className="map-title">{mensagemTalhao()}</span>
            <span style={{ textAlign: 'right', display: 'block', marginTop: '-1.65em' }}>
              <button
                className="add-talhao-button"
                onClick={
                  (): void => {
                    handleTalhaoButton();
                  }
                }
                type="button"
              >
                {
                  drawEnabled
                    || editEnabled
                    || talhaoPendenteRegistro
                    ? (
                      <div>
                        <Clear style={{ margin: '-10px 0 -7px 0' }} />
                        Cancelar
                      </div>
                    )
                    : (
                      <span
                        className="button-adicionar-talhao"
                        style={{ textDecoration: 'underline' }}
                      >
                        <PlusOutlined style={{ marginRight: '2px' }} />
                        Adicionar talhão
                      </span>
                    )
                }
              </button>
            </span>
          </div>
        </div>
        <CustomMap
          id="map-google"
          ref={mapReference}
          center={currentPosition}
          zoom={13}
        >
          {
            enableGeoSearch && (drawEnabled || editEnabled)
              ? (
                <Control position="topleft" className="search-bar">
                  <AutocompleteGoogleMaps
                    handleSelectedLocation={handleSelectedLocation}
                    handleMarkerPosition={handleMarkerPosition}
                  />
                </Control>
              )
              : null
          }
          <LayersControl>
            <LayersControl.BaseLayer checked name="Google Maps Satellite">
              <GoogleLayer
                googlekey={MAP_API_KEY}
                maptype="HYBRID"
                version={MAP_CHANNEL_VERSION}
              />
            </LayersControl.BaseLayer>
          </LayersControl>
          <FeatureGroup>
            <EditControl
              ref={drawControlReference}
              position="topright"
              onCreated={
                (eventt: any): void => {
                  if (editEnabled) {
                    onShapeCreatedEdit(eventt);
                  } else {
                    onShapeCreatedDraw(eventt);
                  }
                }
              }
              draw={{
                polyline: false,

                polygon: {
                  allowIntersection: false,

                  drawError: {
                    color: '#b00b00',
                    timeout: 1000,
                    message: '<strong>Erro: </strong>As bordas não podem se cruzar',
                  },

                  shapeOptions: {
                    color: '#ff5700',
                    opacity: '1',
                    fillColor: 'rgba(36, 101, 74, 0.6)',
                    fillOpacity: '1',
                  },
                },

                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false,
              }}
            />

            {desenhoTalhoes()}
          </FeatureGroup>
          {
            (!editEnabled && !drawEnabled)
              ? markersTalhoesSelecionados.map(
                (value, index) => (
                  <Marker
                    key={`selecionado-${index}`}
                    position={value}
                    icon={iconeSelecionado}
                  >
                    <Popup>Selecionado</Popup>
                  </Marker>
                ),
              )
              : null
          }

          {
            drawEnabled
              ? (
                <div>
                  <Control
                    style={{ marginLeft: '24px', marginRight: '24px' }}
                    position="bottomleft"
                  >
                    <Card
                      size="small"
                      className="GeoMap__card-tooltip-desenho"
                    >
                      <Card.Meta
                        className="GeoMap__meta-tooltip-desenho"
                        avatar={<InfoCircleOutlined />}
                        description="Para desenhar o talhão, inclua os pontos que o contornam, de forma sequencial, sem cruzar as linhas traçadas."
                      />
                    </Card>
                  </Control>
                </div>
              )
              : ''
          }

          {
            editEnabled
              ? (
                <div>
                  <Control position="bottomleft">
                    <Card size="small" className="GeoMap__card-tooltip-desenho">
                      <Card.Meta
                        className="GeoMap__meta-tooltip-desenho"
                        avatar={<InfoCircleOutlined />}
                        description={
                          novoDesenhoFinalizado
                            ? (
                              <Typography.Text
                                className="GeoMap__UpdatedAreaCard"
                              >
                                {
                                  `Área do talhão atualizada: ${showAreaTalhao()} hectares`
                                }
                              </Typography.Text>
                            )
                            : 'Desenhe o novo talhão que substituirá o desenho antigo. Para desenhar o talhão, inclua os pontos que o contornam, de forma sequencial, sem cruzar as linhas traçadas.'
                        }
                      />
                    </Card>
                  </Control>
                </div>
              )
              : ''
          }

          {
            editEnabled
              ? (
                <Control position="topleft">
                  <Button
                    icon={
                      exibirDesenhoAnterior ? <EyeInvisibleOutlined /> : <EyeOutlined />
                    }
                    onClick={(): void => {
                      if (exibirDesenhoAnterior) {
                        toggleDesenhoAnterior(false);
                      } else {
                        toggleDesenhoAnterior(true);
                      }
                    }}
                  >
                    {
                      exibirDesenhoAnterior
                        ? 'Ocultar desenho anterior'
                        : 'Exibir desenho anterior'
                    }
                  </Button>
                </Control>
              )
              : ''
          }

          {
            drawEnabled || editEnabled || talhaoPendenteRegistro
              ? (
                <div>
                  <Control position="topright">
                    <Button
                      icon={<CheckOutlined />}
                      onClick={
                        (): void => {
                          if (editEnabled) {
                            salvarEdicaoDesenhoTalhao();
                          } else {
                            abrirModalTalhao();
                          }
                        }
                      }
                      disabled={
                        !talhaoPendenteRegistro
                        && !talhaoPendenteConfirmacaoEdicao
                      }
                    >
                      Avançar
                    </Button>
                  </Control>
                  <Control position="topright">
                    <Tooltip placement="top" title="Desfazer">
                      <Button
                        onClick={
                          (): void => {
                            desfazer();
                          }
                        }
                        disabled={
                          (!drawEnabled && !editEnabled)
                          || (talhaoPendenteRegistro || talhaoPendenteConfirmacaoEdicao)
                        }
                        style={{ fontSize: '1em', width: '32px', padding: '4px 0' }}
                      >
                        <Undo style={{ padding: '0', fontSize: '1em' }} />
                      </Button>
                    </Tooltip>
                  </Control>
                  <Control position="topright">
                    <Tooltip placement="top" title="Apagar">
                      <Button
                        onClick={
                          (): void => {
                            handleCancelButton();
                          }
                        }
                        disabled={
                          (!drawEnabled && !talhaoPendenteRegistro)
                          && (!editEnabled && !talhaoPendenteConfirmacaoEdicao)
                        }
                        style={{ fontSize: '1em', width: '32px', padding: '4px 0' }}
                      >
                        <Eraser style={{ padding: '0', fontSize: '1em' }} />
                      </Button>
                    </Tooltip>
                  </Control>
                </div>
              )
              : ''
          }

        </CustomMap>

        {
          (exibirCardsTalhaoInfo)
            ? (
              <div className="map-card-container">
                <Card
                  size="small"
                  className="map-card"
                  title={
                    talhaoEmDestaque.id
                      ? (
                        <div>
                          <span className="title">
                            {talhaoEmDestaque.id && talhaoEmDestaque.name}
                          </span>

                          <br />

                          <span className="subtitle">
                            {
                              talhaoEmDestaque.id
                              && cultures
                              && cultures.filter(
                                (culture) => culture.id === talhaoEmDestaque.culture,
                              ).length
                              && (cultures.find(
                                (culture) => culture.id === talhaoEmDestaque.culture,
                              ).description || '')
                            }
                          </span>
                        </div>
                      )
                      : (
                        <div className="title">Nenhum talhão selecionado</div>
                      )
                  }
                  extra={
                    talhaoEmDestaque.id
                      ? (
                        <Dropdown
                          overlayClassName="dropdownLandFieldOptions"
                          overlay={(
                            <Menu
                              items={[
                                {
                                  key: '0',

                                  label: (
                                    <Button
                                      type="link"
                                      onClick={
                                        (eventt): void => {
                                          eventt.preventDefault();
                                          habilitarEdicaoDesenhoTalhao();
                                        }
                                      }
                                    >
                                      Editar desenho
                                    </Button>
                                  ),
                                },
                                {
                                  key: '1',

                                  label: (
                                    <Button
                                      type="link"
                                      onClick={
                                        (eventt): void => {
                                          eventt.preventDefault();
                                          habilitarEdicaoInfoTalhao();
                                        }
                                      }
                                    >
                                      Editar informações
                                    </Button>
                                  ),
                                },
                                {
                                  key: '2',

                                  label: (
                                    <Button
                                      type="link"
                                      onClick={
                                        (eventt): void => {
                                          eventt.preventDefault();
                                          deletarTalhaoDestacado();
                                        }
                                      }
                                    >
                                      Excluir
                                    </Button>
                                  ),
                                },
                              ]}
                            />
                          )}
                          trigger={['click']}
                        >
                          <Button
                            type="link"
                            size="small"
                          >
                            <MoreOutlined style={{ color: '#505050' }} />
                          </Button>
                        </Dropdown>
                      )
                      : ''
                  }
                >
                  {
                    talhaoEmDestaque.id
                      ? (
                        <div className="body">
                          {talhaoEmDestaque.id && talhaoEmDestaque.details}
                        </div>
                      )
                      : ''
                  }
                </Card>
                <Card
                  size="small"
                  className="map-card"
                >
                  <span className="selected">
                    {
                      talhoesSelecionados.length === 1
                        ? '1 talhão selecionado'
                        : `${talhoesSelecionados.length.toString()} talhões selecionados`
                    }
                    {
                      talhoesSelecionados.length > 0
                        ? (
                          <span className="subtitle">
                            <AreaTalhao talhoesSelecionados={talhoesSelecionados} />
                          </span>
                        )
                        : ''
                    }
                  </span>
                </Card>
              </div>
            ) : ''
        }

        <Modal
          title={editInfoEnabled ? 'Editar Talhão' : 'Novo Talhão'}
          centered
          visible={modalTalhaoVisible}
          confirmLoading={salvarTalhaoLoading}
          onOk={
            editInfoEnabled
              ? (): Promise<void> => salvarEdicaoInfoTalhao()
              : (): Promise<void> => salvarNovoTalhao()
          }
          onCancel={
            editInfoEnabled
              ? (): void => cancelarEdicaoInfoTalhao()
              : (): void => cancelarNovoTalhao()
          }
        >
          <Form
            scrollToFirstError
            form={formInstance}
            layout="vertical"
          >
            <Form.Item
              label="Nome"
              name="name"
              initialValue={
                editInfoEnabled
                  ? talhaoEmDestaque.name
                  : ''
              }
              rules={[
                {
                  required: true,
                  message: 'Nome é um campo obrigatório.',
                },
                {
                  max: 150,
                  message: 'O nome informado excede o tamanho maximo de 150 caracteres.',
                },
                {
                  min: 3,
                  message: 'O nome deve ter no mínimo 3 caracteres.',
                },
              ]}
            >
              <Input placeholder="Insira o nome do talhão" />
            </Form.Item>

            <Form.Item
              label="Cultura"
              name="culture"
              initialValue={
                editInfoEnabled
                  ? talhaoEmDestaque.culture
                  : undefined
              }
              rules={[
                {
                  required: true,
                  message: 'Cultura é um campo obrigatório.',
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Selecione a cultura do talhão"
                optionFilterProp="children"
                filterOption={
                  (input, option): any => option.props.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {
                  cultures?.map(
                    (culture) => (
                      <Select.Option
                        key={culture.id}
                      >
                        {culture.description}
                      </Select.Option>
                    ),
                  )
                }
              </Select>
            </Form.Item>

            <Form.Item
              label="Outras Informações"
              name="details"
              initialValue={
                editInfoEnabled
                  ? talhaoEmDestaque.details
                  : ''
              }
              rules={[
                {
                  max: 1000,
                  message: 'Os detalhes informados excedem o tamanho maximo de 1000 caracteres.',
                },
              ]}
            >
              <Input.TextArea placeholder="Insira as informações do talhão" />
            </Form.Item>
          </Form>
          <Row>
            <Col span={2}>
              <Typography.Text
                className="GeoMap__LabelAreaForm"
              >
                Área:
              </Typography.Text>
            </Col>
            <Col span={12}>
              <Typography.Text
                className="GeoMap__TypographyAreaForm"
              >
                {
                  `${showAreaTalhao()} hectares`
                }
              </Typography.Text>
            </Col>
          </Row>
        </Modal>
        <Row
          style={{ marginTop: '20px', minHeight: '60px' }}
        >
          <Col
            xs={{ span: talhoesSelecionados.length === 0 ? 0 : 24 }}
            sm={{ span: talhoesSelecionados.length === 0 ? 0 : 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
            style={{ minHeight: '50px' }}
          />
          <Col
            xs={{ span: talhoesSelecionados.length === 0 ? 0 : 24 }}
            sm={{ span: talhoesSelecionados.length === 0 ? 0 : 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
            style={{ minHeight: '50px' }}
          />
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <Button
              type="link"
              onClick={
                (): any => previousPage({
                  talhoesSelecionados: talhoesSelecionados.map((talhao) => ({
                    ...talhao,
                    culture: cultures.find((v) => v.id === talhao.culture),
                  })),
                })
              }
              className="go-back-map-button"
              icon={<ArrowLeftOutlined />}
            >
              Voltar
            </Button>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ offset: 12, span: 12 }}
            lg={{ offset: 0, span: 6 }}
            xl={{ offset: 0, span: 6 }}
            xxl={{ offset: 0, span: 6 }}
          >
            <Button
              onClick={
                async (): Promise<void> => {
                  let responseSubtype: ResponseWrapper | undefined;
                  let responseSubtypeError: ResponseWrapper | undefined;
                  let genericSubtypeError: Error | undefined;

                  let subTypeDynamicFieldsAux = [];
                  let newTypeFields = params.serviceTypeDynamicFields;

                  if (validarTalhoes()) {
                    if (params?.selectedSubType?.id) {
                      const finalculture = talhoesSelecionados[0].culture;
                      if (
                        params?.selectedSubType?.id == 5
                        && params.selectedType.id == 1
                        && finalculture == '051'
                      ) {
                        try {
                          const subtypeDynamicFieldReqRef: RequestWrapper = get({
                            url: `/service/subtypeDynamicField/${params.selectedSubType.id}/${finalculture}`,

                            frontConfigs: {
                              navigateFunction: navigate,
                            },
                          });

                          responseSubtype = await subtypeDynamicFieldReqRef;
                        } catch (error) {
                          if (!(error instanceof SessionExpiredException)) {
                            message.error('Ocorreu um erro ao buscar os campos do subtipo do serviço, tente novamente');
                          }

                          return;
                        }
                      } else {
                        try {
                          const subtypeDynamicField2ReqRef: RequestWrapper = get({
                            url: `/service/subtypeDynamicField/${params.selectedSubType.id}`,

                            frontConfigs: {
                              navigateFunction: navigate,
                            },
                          });

                          responseSubtype = await subtypeDynamicField2ReqRef;
                        } catch (error) {
                          if (!(error instanceof SessionExpiredException)) {
                            message.error('Ocorreu um erro ao buscar os campos do subtipo do serviço, tente novamente');
                          }

                          return;
                        }
                      }

                      if (!responseSubtype?.body.error) {
                        newTypeFields = [];
                        subTypeDynamicFieldsAux = responseSubtype?.body.serviceSubtypeDynamicFields;
                      }
                    }

                    if (
                      (talhoesSelecionados.length > 1
                        && params.selectedType.idCode === 'GEOFERT-ZONA_MANEJO'
                        && (
                          params.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-VANT'
                          || params.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-SATELITE'
                          || params.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA'
                        ))
                    ) {
                      Modal.confirm({
                        title: 'Atenção!',
                        icon: <ExclamationCircleOutlined />,
                        content: 'Todas as informações preenchidas serão válidas para todos os talhões selecionados.',
                        okText: 'OK',
                        okType: 'warning',
                        cancelText: 'Cancelar',

                        onOk() {
                          nextPage({
                            talhoesSelecionados: talhoesSelecionados.map((talhao) => ({
                              ...talhao,
                              culture: cultures.find((v) => v.id === talhao.culture),
                            })),
                            serviceSubtypeDynamicFields: subTypeDynamicFieldsAux,
                            serviceTypeDynamicFields: newTypeFields,
                          });
                        },

                        onCancel() {
                          console.log('Cancel');
                        },
                      });
                    } else {
                      nextPage({
                        talhoesSelecionados: talhoesSelecionados.map((talhao) => ({
                          ...talhao,
                          culture: cultures.find((v) => v.id === talhao.culture),
                        })),
                        serviceSubtypeDynamicFields: subTypeDynamicFieldsAux,
                        serviceTypeDynamicFields: newTypeFields,
                      });
                    }
                  }
                }
              }
              className="go-forward-map-button"
              disabled={
                talhoesSelecionados.length === 0
                || drawEnabled
                || talhaoPendenteRegistro
                || editEnabled
              }
            >
              Continuar
            </Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

GeoMap.propTypes = {
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,

  params: PropTypes.shape({
    selectedProperty: PropTypes.shape({
      id: PropTypes.number,

      location: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),

      matriculation: PropTypes.string,
      name: PropTypes.string,
      registeredOn: PropTypes.string,
    }),

    selectedSubType: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),

    talhoesSelecionados: PropTypes.arrayOf(PropTypes.shape({
      area: PropTypes.number,

      culture: PropTypes.shape({
        description: PropTypes.string,
        id: PropTypes.string,
      }),

      details: PropTypes.string,
      id: PropTypes.number,
      landId: PropTypes.number,
      name: PropTypes.string,
    })),

    selectedService: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),

    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
  }),
};

GeoMap.defaultProps = {
  params: {},
};

export default GeoMap;
